import {Action} from '@ngrx/store';
import {App, AppId} from '../../shared/models/app';
import {TileGroup} from '../../shared/models/tile-group';

export const APPS_CHANGED_ID = '[Apps] changed app ID';
export const APPS_FETCHED_ALL = '[Apps] fetched all apps';
export const APPS_FETCHED_MULTIPLE = '[Apps] fetched multiple apps';
export const APPS_FETCHED_ONE = '[Apps] fetched one app';
export const APPS_DELETED_APP = '[Apps] deleted app';
export const APPS_SAVED_TILE_GROUPS = '[Apps] saved tiles groups';

/**
 * For whenever an app loads; its ID is broadcasted here
 */
export class AppsChangedId implements Action {
  readonly type = APPS_CHANGED_ID;

  constructor(public appId: AppId) {
  }
}

/**
 * For when a call to any endpoint returns an array of apps, where
 * that array might not be the complete set of apps accessible to
 * the user
 */
export class AppsFetchedMultiple implements Action {
  readonly type = APPS_FETCHED_MULTIPLE;

  constructor(public apps: App[]) {
  }
}

/**
 * For when a call to /apps/user is made and all App objects are now
 * known and stored
 */
export class AppsFetchedAll implements Action {
  readonly type = APPS_FETCHED_ALL;

  constructor(public apps: App[]) {
  }
}

/**
 * For when a call to /apps/{appID} is made and a single App object
 * is retrieved from API
 */
export class AppsFetchedOne implements Action {
  readonly type = APPS_FETCHED_ONE;

  constructor(public appId: AppId, public appObj: App) {
  }
}

export class AppsDeletedApp implements Action {
  readonly type = APPS_DELETED_APP;

  constructor(public appId: AppId) {
  }
}

export class AppsSavedTileGroups implements Action {
  readonly type = APPS_SAVED_TILE_GROUPS;

  constructor(public appId: AppId, public tileGroups: TileGroup[]) {
  }
}

export type Actions = AppsChangedId
  | AppsFetchedAll
  | AppsFetchedOne
  | AppsFetchedMultiple
  | AppsDeletedApp
  | AppsSavedTileGroups;
